<template>
  <div class="input-wrapper">
    <div class="label-wrapper">
      <label :for="getId">{{ label }}</label>
      <span class="error-message">Can't be zero</span>
    </div>
    <img :src="url" alt="Input Icon" class="input-icon" />
    <input
      min="1"
      required
      step="any"
      :id="getId"
      type="number"
      placeholder="0"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'number-input',
  props: {
    url: String,
    label: { type: String, required: true },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  computed: {
    getId(): string {
      return this.label.replaceAll(' ', '-').toLowerCase();
    },
  },
});
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;

  .input-icon {
    position: absolute;
    bottom: 0.7rem;
    left: 1rem;
  }
}

.label-wrapper {
  display: flex;
  justify-content: space-between;
}

.error-message {
  color: darken($color: $error-red, $amount: 10);
  display: none;
}

label {
  display: block;
  margin-bottom: 0.75rem;
}

input {
  outline: none;
  border: 0.2rem solid transparent;
  border-radius: 0.3rem;
  background-color: $ligher-cyan;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  padding: 0.5rem 1rem;

  color: inherit;
  font-family: inherit;
  font-weight: 700;
  text-align: right;

  width: 100%;

  transition: all 0.2s;

  &:focus {
    &:valid {
      border-color: $primary-cyan;
    }

    &:invalid {
      border-color: $error-red;
    }
  }
}
</style>
